import React, { useState } from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CustomLink from './CustomLink';

const LegalDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        role='button'
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleMouseEnter}
      >
        <Typography
          style={{
            color: 'white',
            textTransform: 'none',
            marginRight: '4px',
            fontSize: '0.875rem',
          }}
        >
          Legal
        </Typography>
        <ArrowDropDownIcon style={{ color: 'white' }} />
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMouseLeave}
        MenuListProps={{
          onMouseEnter: () => setAnchorEl(anchorEl),
          onMouseLeave: handleMouseLeave,
        }}
      >
        <MenuItem component={CustomLink} to='/content/privacy-policy' onClick={handleMouseLeave}>
          <Typography variant='body2'>Privacy Policy</Typography>
        </MenuItem>
        <MenuItem component={CustomLink} to='/content/terms-of-service' onClick={handleMouseLeave}>
          <Typography variant='body2'>Terms of Service</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default LegalDropdown;
